/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Thu Mar 23 2023
 **/

import cx from "classnames";
import { useTheme } from "@emotion/react";

import { Maybe } from "@/frameworks/libraries/components";

import { wrapperStyle, dotStyle } from "./private/emotion";

export interface ActiveStatusProps extends React.HTMLAttributes<HTMLDivElement> {
	active?: boolean;
	position?: "topLeft" | "topRight" | "bottomLeft" | "bottomRight" | "topCenter" | "RightCenter";
}

export default function ActiveStatus({ active = false, position = undefined, className, children }: ActiveStatusProps) {
	const theme = useTheme();
	return (
		<div className={cx(className)} css={wrapperStyle}>
			{children}
			<Maybe test={active}>
				<div css={[dotStyle(theme, position)]}></div>
			</Maybe>
		</div>
	);
}
